import { useTranslations } from '@/hooks/useTranslations'

import type { Product } from '@/gen/ecom'

export const usePackagingDescription = (productData?: Product) => {
  const { translate } = useTranslations()

  if (!productData?.salesUnits?.conversions) {
    return 'N/A'
  }

  return productData?.salesUnits?.conversions
    .map((conversion) => {
      if (
        !conversion.unit ||
        conversion.unit?.toLowerCase() === productData?.salesUnits?.defaultSalesUnit?.toLowerCase() ||
        conversion.unit?.toLowerCase() === productData?.packageUnit?.toLowerCase()
      ) {
        return
      }

      const defaultPackageUnit = translate(
        `page.product.details.salesUnit.${productData?.salesUnits?.defaultSalesUnit?.toLowerCase()}`
      )
      const unit = translate(`page.product.details.salesUnit.${conversion.unit?.toLowerCase()}`)
      const factor = Math.ceil(1 / Number.parseFloat(conversion.factor ?? '1.0'))

      return `${unit} a ${factor} ${defaultPackageUnit}`
    })
    .filter(Boolean)
    .join(' | ')
}
